import { render, staticRenderFns } from "./ModalErrorPlacingOrder.vue?vue&type=template&id=40c08a79"
import script from "./ModalErrorPlacingOrder.vue?vue&type=script&lang=js"
export * from "./ModalErrorPlacingOrder.vue?vue&type=script&lang=js"
import style0 from "./ModalErrorPlacingOrder.vue?vue&type=style&index=0&id=40c08a79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports